<template>
  <div class="dropdown-item" @click="handleClick">
    <span class="icon-action">
      <i :class="iconClass"></i>
      {{ label }}
    </span>
  </div>
</template>

<script>
export default {
  name: "DropdownActionItem",
  props: {
    baseRoute: {
      type: String,
      required: true
    },
    canUpdate: {
      type: Boolean,
      default: false
    },
    canRead: {
      type: Boolean,
      default: true
    },
    editLabel: {
      type: String,
      default: "Edit"
    },
    viewLabel: {
      type: String,
      default: "View"
    }
  },
  computed: {
    isEditable() {
      return this.canUpdate && this.canRead;
    },
    label() {
      return this.isEditable ? this.editLabel : this.viewLabel;
    },
    iconClass() {
      return this.isEditable ? "flaticon-pencil" : "flaticon-visualization";
    }
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: this.baseRoute,
        query: { mode: this.isEditable ? "edit" : "view" }
      });
    }
  }
};
</script>
